import { PostRequest } from "../api"

export const makePostRequest = (url, data) => {
  return new Promise((resolve, reject) => {
    PostRequest(url, data)
      .then((res) => {
        if (res.status === 'Success') {
          resolve(res)
        } else {
          reject(res.ErrMessage || 'Error processing request')
        }
      })
      .catch((err) => reject(err))
  })
}
export const makeGetRequest = (url, data) => {
  return new Promise((resolve, reject) => {
    PostRequest(url, data)
      .then((res) => {
        if (res.status === 'Success') {
          resolve(res)
        } else {
          reject(res.ErrMessage || 'Error processing request')
        }
      })
      .catch((err) => reject(err))
  })
}